
<template>
  <div>
    <div class="main" v-if="businessRun">
      <div class="leftAuthor">
        <Anchor :getContainer="getContainer">
          <Link
            v-for="(x, index) in rightList"
            :key="index"
            :href="hrefUrl(x)"
            :title="x.typeName"
          />
        </Anchor>
      </div>
      <div class="rightList">
        <div v-for="y in rightList" :key="y.id" :id="y.id">
          <div class="content">
            <div class="title">{{ y.typeName }}</div>
            <div class="menu">
              <CoffeeItem
                v-for="(item, index) in y.drinks"
                :key="index"
                :class="{ marginleft: index % 5 !== 0 }"
                :coffee_info="item"
                :disabled="false"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!businessRun" class="no-data-view">
      <img
        class="no-data-img"
        src="../../../static/img/meals/pic_default_null.png"
      />
      <!-- <span class="text-one">暂无数据</span>
      <span class="text-two">商家该时段暂停营业</span> -->
      <p class="notice-title" v-html="notice"></p>
    </div>
  </div>
</template>

<script>
import { Anchor } from "ant-design-vue";
import "ant-design-vue/lib/anchor/style/css";
import CoffeeItem from "./components/CoffeeItem.vue";

const { Link } = Anchor;

const apiUrl = {
  menuListUrl: "/drinks/customer/GetAllDrinks",
};
const { menuListUrl } = apiUrl;
export default {
  components: {
    Anchor,
    Link,
    CoffeeItem,
  },
  data() {
    return {
      orderState: false, //能否下单
      rightList: [], // 右侧具体数据
      businessRun: true, //商家经验状态
      getContainer: () => {},
      notice: "",
    };
  },
  mounted() {
    this.getMenuList();
    this.getStatus();
    this.getContainer = () => {
      return document.querySelector(".meals-container");
    };
  },
  computed: {
    // 是否能够下单
    allowOrder() {
      return this.orderState === true;
    },
    // 获取动态锚点映射地址
    hrefUrl() {
      return (x) => {
        return `#${x.id}`;
      };
    },
  },
  methods: {
    // 获取营业状态
    getStatus(status) {
      this.axios
        .get("/drinks/order/getBusiness")
        .then((res) => {
          if (res.code === 0) {
            this.businessRun = res.data.business;
            if (!this.businessRun) {
              this.getNotice();
            }
          }
        })
        .catch(() => {});
    },
    // 获取公告
    getNotice() {
      this.axios
        .get("/drinks/admin/getNotice")
        .then((res) => {
          if (res.code === 0) {
            this.notice = res.data.notice;
          }
        })
        .catch(() => {});
    },
    //获取所有饮品信息
    getMenuList() {
      this.axios
        .get(menuListUrl)
        .then((res) => {
          if (res.code === 0) {
            //设置右侧值
            this.rightList = res.data.result;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("获取咖啡菜单失败！");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  margin-top: 20px;
}
.leftAuthor {
  width: 250px;
  flex: inherit;
  position: fixed;
  left: 25px;
}
.rightList {
  padding: 20px;
  margin-left: 300px;
  padding-left: 0;
  flex: 1;
  background: #f5f5f5;
}
.ant-anchor-wrapper {
  padding: 20px 0 0 50px !important;
}
.content {
  display: flex;
  margin-bottom: 20px;
}
.title {
  width: 120px;
  text-align: right;
  padding-right: 5px;
  font-size: 20px;
  font-weight: bold;
}
.notice-title {
  width: 400px;
  text-align: left;
  padding-right: 5px;
  font-size: 20px;
  font-weight: bold;
}
.menu {
  flex: 1;
}
.menu {
  display: flex;
  flex-wrap: wrap;
  margin-top: 35px;
  margin-left: 15px;
}
.no-data-view {
  width: 400px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  margin-top: 90px;
  .no-data-img {
    width: 190px;
    height: 146px;
  }
  .text-one {
    font-size: 24px;
    color: #333333;
    margin-top: 20px;
  }
  .text-two {
    font-size: 16px;
    color: #999999;
    margin-top: 10px;
  }
}
/deep/ .ant-anchor-link-active > .ant-anchor-link-title {
  color: #ff9a28;
}
/deep/ .ant-anchor-ink-ball {
  border: 2px solid #ff9a28;
}
/deep/ a:hover {
  color: #ff9a28 !important;
}
/deep/ .ant-anchor-wrapper {
  padding-left: 13px;
}
/deep/ .ant-anchor-link {
  padding: 5px 0 5px 16px;
  line-height: 2.143;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/coffee/Coffee.vue